/**
 * @documental
 * @export Placeholder
 * @name
 * TextArea.Placeholder
 */

import { FC } from "react";
import Skeleton from "react-loading-skeleton";
import { BaseProps } from "../../BaseProps";
import { getBasePropsFromHtmlProps } from "../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import { Body } from "capitalrx-components-2.0/lib/typography";
import { InputContainerPlaceholder } from "../shared/InputContainer/InputContainerPlaceholder";
import styles from "./styles.module.scss";
import { AccessibilityProps } from "../../AccessibilityProps";

/**
 * The `Placeholder` component properties.
 */

export interface PlaceholderProps extends BaseProps, AccessibilityProps {
  /**
   * The number of lines displayed in the text area.
   */
  readonly lines?: number;

  /**
   * Indicates whether the text area has instructions. If not specified defaults to `false`.
   */
  readonly hasInstructions?: boolean;
}

/**
 * A loading placeholder for the `TextArea` component.
 */
export const Placeholder: FC<PlaceholderProps> = (props) => {
  const { lines, hasInstructions = false, "aria-label": ariaLabel } = props;

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [
      styles.TextAreaPlaceholder,
      "text-area",
      "placeholder",
      {
        "fixed-height": lines !== undefined,
      },
    ],
    testIdPrefix: "text-area-placeholder",
  });

  return (
    <InputContainerPlaceholder {...getBasePropsFromHtmlProps(baseHtmlProps)} hasInstructions={hasInstructions}>
      <Body className="input-container">
        <textarea className="input" rows={lines} readOnly disabled aria-label={ariaLabel} />
        <Skeleton />
      </Body>
    </InputContainerPlaceholder>
  );
};
